<template>
  <div class="eds-field" :class="[formFieldClass]" :style="[formFieldStyle]">
    <span class="field-label" :class="[labelClass]" :style="[labelStyle]">
      {{ label }}
      <slot v-if="label && $attrs.required" name="required">
        <sup className="ev-text-red-500"> *</sup>
      </slot>
    </span>
    <slot />
    <div
      v-if="message"
      class="field-assistive-text"
      :class="[`field-${messageType}`, messageClass]"
      :style="[messageStyle]"
    >
      {{ message }}
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'FormField',
    props: {
      label: {
        type: String,
        required: false,
        default: '',
      },
      formFieldClass: {
        type: String,
        required: false,
        default: '',
      },
      formFieldStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      labelClass: {
        type: String,
        required: false,
        default: '',
      },
      labelStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      message: {
        type: String,
        required: false,
        default: '',
      },
      messageType: {
        type: String,
        required: false,
        default: 'basic',
        validator: (value: string) => {
          return ['basic', 'warning', 'error'].includes(value);
        },
      },
      messageClass: {
        type: String,
        required: false,
        default: '',
      },
      messageStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
  });
</script>

<style></style>
